// extracted by mini-css-extract-plugin
export default {"linkStyleCopy":"r3-z","paperCutsLineHeight":"s3-z"};